import { SerializedSmartLinkVersionTheme } from 'fym-shared/src/smartlinks/types';
import bloom from '../../assets/images/theme-previews/bloom-mobile.jpeg';
import cassette from '../../assets/images/theme-previews/cassette-mobile.jpeg';
import chill from '../../assets/images/theme-previews/chill-mobile.jpeg';
import chrome from '../../assets/images/theme-previews/chrome-mobile.jpeg';
import dark from '../../assets/images/theme-previews/dark-mobile.jpeg';
import deep from '../../assets/images/theme-previews/deep-mobile.jpeg';
import ember from '../../assets/images/theme-previews/ember-mobile.jpeg';
import frost from '../../assets/images/theme-previews/frost-mobile.jpeg';
import grid from '../../assets/images/theme-previews/grid-mobile.jpeg';
import loli from '../../assets/images/theme-previews/loli-mobile.jpeg';
import neon from '../../assets/images/theme-previews/neon-mobile.jpeg';
import paper from '../../assets/images/theme-previews/paper-mobile.jpeg';
import riso from '../../assets/images/theme-previews/riso-mobile.jpeg';
import velvet from '../../assets/images/theme-previews/velvet-mobile.jpeg';

/**
 * A shot of each page theme, shipped inside the app.
 *
 * These used to come from statics.freeyourmusic.com, which meant every new
 * theme needed a CDN upload before its swatch stopped 404ing, and local
 * development never showed them at all. Importing them instead lets each
 * bundler resolve the asset its own way: webpack gives a URL, Metro gives an
 * asset reference. Regenerate with `pnpm images` in sml-preview/scripts.
 */
export const themePreviews: Record<SerializedSmartLinkVersionTheme, string> = {
  [SerializedSmartLinkVersionTheme.chill]: chill,
  [SerializedSmartLinkVersionTheme.deep]: deep,
  [SerializedSmartLinkVersionTheme.dark]: dark,
  [SerializedSmartLinkVersionTheme.loli]: loli,
  [SerializedSmartLinkVersionTheme.paper]: paper,
  [SerializedSmartLinkVersionTheme.neon]: neon,
  [SerializedSmartLinkVersionTheme.cassette]: cassette,
  [SerializedSmartLinkVersionTheme.velvet]: velvet,
  [SerializedSmartLinkVersionTheme.frost]: frost,
  [SerializedSmartLinkVersionTheme.bloom]: bloom,
  [SerializedSmartLinkVersionTheme.grid]: grid,
  [SerializedSmartLinkVersionTheme.ember]: ember,
  [SerializedSmartLinkVersionTheme.chrome]: chrome,
  [SerializedSmartLinkVersionTheme.riso]: riso,
};

/** Falls back to the default theme's shot for a value the app does not know. */
export function themePreview(theme: string): string {
  return themePreviews[theme as SerializedSmartLinkVersionTheme] ?? themePreviews[SerializedSmartLinkVersionTheme.dark];
}
